const docFields = {
  fields: "Fields",
  formFields: "Form Fields",
  addField: "Add Field",
  noFields: "No fields — add fields for submitters to fill in",
  label: "Label",
  placeholder: "Placeholder",
  options: "Options",
  option: "Option",
  addOption: "Add option",
  required: "Required field",
} as const;
export default docFields;
